<template>
    <div id="chart" class='bg-site-primary p-2' v-if="userInfo.listMonths && Object.keys(userInfo.listMonths).length > 0 ">
        <apexchart  height="200" :options="chartOptions" :series="series"></apexchart>

        

    </div>
</template>
<script setup>

import { ref, computed } from 'vue';
import { UserInfo } from '@/stores/UserInfo';

const userInfo = ref(UserInfo());

const series = computed(() => {
    const currentMonthKey = new Date().getMonth() -1;

    const currentMonthData = userInfo.value.listMonths[currentMonthKey];





    const data = [];
    let i = 1;
    if (currentMonthData && currentMonthData.month && Object.values(currentMonthData.month).length > 0){
    for (const monthData of Object.values(currentMonthData.month)) {



        for (const weekData of monthData) {

            let object = {
                name: 'Week ' + i,
                data: []
            }
            i++;

            let y_ = 1;
            for (const dayData of weekData.dates) {
                const weight = dayData.weightChange !== null ? dayData.weightChange : 0;


                object.data.push({
                    x: y_,
                    y: weight,
                    day: dayData.day,
                });

                y_++;
            }

            data.push(object);
        }


    }


    console.log('Weight Values:', data.map(item => item.data.map(entry => entry.y)));

    return data.reverse();

}
else{
    return [];
}


});



const chartOptions = {

    chart: {
        type: 'heatmap',
        zoom: {
            enabled: false
        }
    },
    plotOptions: {
        heatmap: {
            shadeIntensity: 1,
            colorScale: {
                ranges: [
                    {
                        from: 0,
                        to: 100,
                        color: '#E9E9E9',
                        name: 'none',
                    },
                    {
                        from: -0.5,
                        to: -0.4,
                        color: '#80bfff',
                        name: 'low',
                    },
                    {
                        from: -0.9,
                        to: -0.6,
                        color: '#66b3ff',
                        name: 'medium',
                    },
                    {
                        from: -2,
                        to: -1,
                        color: '#1ba6ff',
                        name: 'high',
                    }

                ]
            }
        }
    },
    dataLabels: {
        enabled: false
    },
    xaxis: {
        type: 'category',
    },
    title: {
        text: 'Month',
        align: 'left'
    },
    legend: {},
    tooltip: {
        custom: function ({ seriesIndex, dataPointIndex, w }) {
            var data = w.globals.initialSeries[seriesIndex].data[dataPointIndex];

            return '<div class="tooltip p-1">' +
                '<span> Day: ' + data.day + '</span>' + '<br/>' +
                '<span> Weight Change: ' + data.y + '</span>' +
                '</div>'
        }
    }





};

</script>
<style lang="">
    
</style>